import axios, { AxiosInstance } from "axios";
import { createContext, useRef, ReactNode } from "react";

const AxiosContext = createContext({} as AxiosInstance);

interface AxiosContextType {
  config: any,
  requestInterceptors?: any,
  responseInterceptors?: {responseInterceptor: any, errorInterceptor: any}[],
  children: ReactNode
}

const AxiosInstanceProvider = ({
  config = {},
  //requestInterceptors = [],
 // responseInterceptors = [],
  children,
}: AxiosContextType) => {
  const instanceRef = useRef(axios.create(config));

  // useEffect(() => {
  //   requestInterceptors.forEach((interceptor: any) => {
  //     instanceRef.current.interceptors.request.use(
  //       interceptor
  //     );
  //   });
  //   responseInterceptors.forEach((interceptor: any) => {
  //     instanceRef.current.interceptors.response.use(
  //       interceptor.responseInterceptor, interceptor.errorInterceptor
  //     );
  //   });
  // }, []);

  return (
    <AxiosContext.Provider value={instanceRef.current}>
      {children}
    </AxiosContext.Provider>
  );
};

export { AxiosContext, AxiosInstanceProvider }